import checkDefault from './checkDefault'

const profiles = {
  checkDefault,
}

export default profiles
